import React, { Component } from 'react';
import './notifications.css';
import { FaBell as NotificationBell } from 'react-icons/lib/fa';
import { connect } from 'react-redux';
import {
  anomalyCount,
  failureCount,
  forecastCount,
  setSession,
} from '../../services/testResultsService';

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anomCount: 0,
      failCount: 0,
      foreCount: 0,
      showNotifications: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    this.setOEM();
    anomalyCount(1).then((result) => {
      this.setState({
        anomCount: result.count
      });
    });
    failureCount(1).then((result) => {
      this.setState({
        failCount: result.count
      });
    });
    forecastCount(1).then((result) => {
      this.setState({
        foreCount: result.count
      });
    });
  }

  setOEM = () => {
    const { session } = this.props;
    setSession(session);
  }

  handleClick = () => {
    const { showNotifications } = this.state;
    if (! showNotifications) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
    this.setState(prevState => ({
      showNotifications: ! prevState.showNotifications
    }));
  }

  handleOutsideClick = (e) => {
    if (this.node && this.node.contains(e.target)) {
      return;
    }
    this.handleClick();
  }

  render() {
    const {
      anomCount,
      failCount,
      foreCount,
      showNotifications,
    } = this.state;
    const total = anomCount + failCount + foreCount;
    const listNotifications = `${anomCount} anomalies, 
    ${foreCount} forecasted events and ${failCount} predicted failures detected today.
    Please visit the results tab for more information.`;
    return (
      <div className="notifications-container" ref={node => { this.node = node; }}>
        <NotificationBell className="notification-bell" size={21} onClick={this.handleClick} />
        <span className={total ? 'badge show' : 'hide'}>{total}</span>
        <div className={showNotifications ? 'notifications-list-container show' : 'notifications-list-container hide'}>
          <ul className="notifications-list">
            {listNotifications}
          </ul>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(Notifications);
